import { useState } from "react";
import { Bed } from "lucide-react";
import { cn } from "@/components/utils/utils";

/** Resolves a WorldOTA CDN template URL by replacing {size} with x500. */
export function resolveWorldotaUrl(url: string): string {
  return url.replace("{size}", "x500");
}

interface WorldotaImageProps {
  url: string;
  alt: string;
  className?: string;
  fallback?: React.ReactNode;
  onClick?: () => void;
}

/** Renders a WorldOTA CDN image, resolving the {size} placeholder automatically. Falls back to a placeholder on load error or missing URL. */
export function WorldotaImage({ url, alt, className, fallback, onClick }: WorldotaImageProps) {
  const [error, setError] = useState(false);

  if (!url || error) {
    return (
      <div
        className={cn("flex items-center justify-center bg-gray-100", className)}
        onClick={onClick}
      >
        {fallback ?? <Bed className="h-8 w-8 text-gray-300" />}
      </div>
    );
  }

  return (
    <img
      src={resolveWorldotaUrl(url)}
      alt={alt}
      className={cn("object-cover", className)}
      onError={() => setError(true)}
      onClick={onClick}
    />
  );
}
